export default "__VITE_ASSET__CtTQGr13__"